/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} SubmittedInputs */

const en_submitted = /** @type {(inputs: SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submitted`)
};

const fr_submitted = /** @type {(inputs: SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soumis`)
};

const de_submitted = /** @type {(inputs: SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eingereicht`)
};

const it_submitted = /** @type {(inputs: SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inviato`)
};

const ru_submitted = /** @type {(inputs: SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поданный`)
};

const es_submitted = /** @type {(inputs: SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviado`)
};

const zh_cn2_submitted = /** @type {(inputs: SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已提交`)
};

const ja_submitted = /** @type {(inputs: SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提出済み`)
};

const hi_submitted = /** @type {(inputs: SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रस्तुत किया गया`)
};

const pt_pt2_submitted = /** @type {(inputs: SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviado`)
};

/**
* | output |
* | --- |
* | "Submitted" |
*
* @param {SubmittedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const submitted = /** @type {((inputs?: SubmittedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<SubmittedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_submitted(inputs)
	if (locale === "de") return de_submitted(inputs)
	if (locale === "it") return it_submitted(inputs)
	if (locale === "ru") return ru_submitted(inputs)
	if (locale === "es") return es_submitted(inputs)
	if (locale === "zh-CN") return zh_cn2_submitted(inputs)
	if (locale === "ja") return ja_submitted(inputs)
	if (locale === "hi") return hi_submitted(inputs)
	if (locale === "pt-PT") return pt_pt2_submitted(inputs)
	return en_submitted(inputs)
});